import React, { FC } from 'react';
import { usePublicJobDetailDataQuery } from '../../hooks';
import { PublicJobDetailSimilarJobsCard } from './PublicJobDetailSimilarJobsCard';
import { isNull } from '../../../../../predicates/type';
import { useTranslationAPI } from '../../../../translations';
import { jobModuleCodes } from '../../../../../data/translations/jobModuleCodes';
import { PublicJobDetailSimilarJobsContainer } from 'modules/publicJob/detail/components/PublicJobDetailSimilarJobs';

export const PublicJobDetailSimilarJobs: FC = () => {
	const { translate } = useTranslationAPI();

	const {
		data: { similarJobs },
	} = usePublicJobDetailDataQuery();

	if (isNull(similarJobs)) return null;

	return (
		<PublicJobDetailSimilarJobsContainer title={translate(jobModuleCodes.similarJobs)}>
			{similarJobs.map((job, index) => (
				<PublicJobDetailSimilarJobsCard
					{...job}
					key={index}
				/>
			))}
		</PublicJobDetailSimilarJobsContainer>
	);
};
